import { browserHistory } from 'react-router'
// import axios from 'axios'
// import config from '../config'


// 跳转到对话页
function toChatPage (uid) {
    const enstr = btoa(uid)
    location.assign(`/message/chat/${enstr}`)
}

function toInfoPage (uid) {
    const enstr = btoa(uid)
    location.assign(`/message/info/${enstr}`)
}

// setEvent({name: 'click-channel-pay'})
function setEvent(params) {
    window._czc && window._czc.push(["_trackEvent", params.page || 'common', params.action || 'click', params.name || '', 1])
    // console.log(`set event: ${JSON.stringify(params)}`)
}

// function initWxShare(shareData) {
//     if (window.platform !== 'weixin') return
//     const JSAPI_LIST = [
//         'onMenuShareTimeline',
//         'onMenuShareAppMessage',
//         'onMenuShareQQ',
//         'onMenuShareWeibo',
//         'onMenuShareQZone',
//         'startRecord',
//         'stopRecord',
//         'onVoiceRecordEnd',
//         'playVoice',
//         'pauseVoice',
//         'stopVoice',
//         'onVoicePlayEnd',
//         'uploadVoice',
//         'downloadVoice',
//         'chooseImage',
//         'previewImage',
//         'uploadImage',
//         'downloadImage',
//         'translateVoice',
//         'getNetworkType',
//         'openLocation',
//         'getLocation',
//         'hideOptionMenu',
//         'showOptionMenu',
//         'hideMenuItems',
//         'showMenuItems',
//         'hideAllNonBaseMenuItem',
//         'showAllNonBaseMenuItem',
//         'closeWindow',
//         'scanQRCode',
//         'chooseWXPay',
//         'openProductSpecificView',
//         'addCard',
//         'chooseCard',
//         'openCard',
//     ]
//     axios.get('/api/weixin/jssdk_config', {
//         params: {
//             url: location.href,
//             appid: config.WXAPPID,
//             debug: 0
//         }
//     })
//         .then((res) => {
//             const config = res.data.data
//             window.wx.config({ 
//                 ...config,
//                 appId: config.WXAPPID,
//                 jsApiList: JSAPI_LIST,
//                 debug: false,
//             })
//             window.wx.ready(() => {
//                 const title = shareData.title ? shareData.title.replace(/<\/?[^>]+(>|$)/g, "") : '';
//                 let desc = shareData.desc ? shareData.desc.replace(/<\/?[^>]+(>|$)/g, "") : '';
//                 if(desc.trim().length === 0){
//                     desc = '向你推荐'
//                 }
//                 window.wx.onMenuShareAppMessage({
//                     title: title,
//                     desc: desc,
//                     link: shareData.link,
//                     imgUrl: shareData.imgUrl,
//                     type: shareData.type,
//                     dataUrl: shareData.dataUrl,
//                     success: () => {
                        
//                     },
//                 })
//                 window.wx.onMenuShareTimeline({
//                     title: title,
//                     desc: desc,
//                     link: shareData.link,
//                     imgUrl: shareData.imgUrl,
//                     type: shareData.type,
//                     dataUrl: shareData.dataUrl,
//                     success: () => {
                        
//                     }
//                 });
//             })
//         })
// }


export {
    toInfoPage,
    toChatPage,
    setEvent,
    // initWxShare,
}


// WEBPACK FOOTER //
// ./src/services/index.js